import "./Testimonials.css";

const featuredTestimonial = {
  quote:
    "Mike Ammen is the best consultant I have ever worked with. He has a breadth of expertise in the field, a knack for solving problems, and a passion for delivering value.",
  name: "Dante Salvetti",
  context: "Sales leadership across Intersect ENT, Arrinex, Alydia Health, and Eyenuk",
  label: "4 engagements across 15+ years",
};

const testimonials = [
  {
    id: "dante-salvetti",
    name: "Dante Salvetti",
    role: "Sales Leader",
    companies: "Intersect ENT, Arrinex, Alydia Health, and Eyenuk",
    tag: "Commercial launch",
    paragraphs: [
      "I have worked with Mike Ammen four times in my career as a sales leader, and each time I was impressed by the professionalism, expertise, and results he brought to the business.",
      "At Intersect ENT, he expanded from business planning and reporting into rescuing a CRM implementation that had damaged confidence in the data. He identified the issues quickly, proposed the right fixes, executed them cleanly, and trained the team to use the system effectively.",
      "At Alydia Health, he helped shape commercialization from the start, designing integrated commercial processes, implementing CRM, and making sure we captured the right metrics to guide strategy. He was not only a consultant, but a partner and a mentor who gave us a strong foundation for growth.",
    ],
  },
  {
    id: "robert-binney",
    name: "Robert Binney",
    role: "CEO",
    companies: "Access Closure, Intersect ENT, Alydia Health, and ShiraTronics",
    tag: "Trusted advisor",
    paragraphs: [
      "I have had the pleasure of working with Mike Ammen four times in my career, most recently as CEO of Alydia Health and ShiraTronics. Each time I was amazed by his professionalism, expertise, and results. He is not just a consultant, he is a trusted advisor and a strategic partner.",
      "At Intersect ENT, he built the initial business planners for launch, took over sales reporting, stabilized reporting when CRM and ERP data loads broke down, and created an automated process that restored accuracy and continuity through multiple team transitions.",
      "At Alydia Health, bringing him in early allowed us to satisfy all sales reporting through Salesforce and maintain clean transactional data from the start. During diligence, that discipline gave us credible answers on cycle times and pipeline health, which materially strengthened the value of the company.",
    ],
  },
  {
    id: "james-reinstein",
    name: "James Reinstein",
    role: "Operating Leader",
    companies: "Aptus Endosystems, Cutera, and Saranas",
    tag: "Operational rigor",
    paragraphs: [
      "I've worked with Mike Ammen at all the companies I led since 2012, including Aptus Endosystems, Cutera, and Saranas. His expertise in sales analysis, sales operations, and customer service provided valuable insights and strategies that directly contributed to our commercial success.",
      "His ability to see the big picture of how processes fit together would be an asset to any organization entering the commercial stage. He brings a thorough, data-driven approach, clear communication, and a strong commitment to report accuracy.",
      "His tailored solutions streamlined our operations, improved customer engagement and satisfaction, and played a pivotal role in strategic decision-making. He laid a solid foundation for future growth and success.",
    ],
  },
  {
    id: "tyler-binney",
    name: "Tyler Binney",
    role: "Client Partner",
    companies: "NeoTract and Relievant Medsystems",
    tag: "Continuity + reporting",
    paragraphs: [
      "Having worked with Mike Ammen and Ammen Consulting at both NeoTract and Relievant Medsystems, I can attest to the exceptional level of service and expertise they bring to the table.",
      "At NeoTract, Mike was instrumental in scaling our metrics and reporting, giving us the clarity and precision needed to move the business forward. His ability to understand and adapt to our unique needs made a significant impact on our operations.",
      "At Relievant Medsystems, he provided continuity for our incentive compensation program during a period of transition. His dedication, professionalism, and results-driven mindset made him an invaluable partner.",
    ],
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="section-shell">
        <div className="testimonials-shell">
          <div className="testimonials-header">
            <span className="eyebrow">What our clients have to say</span>
            <h2 className="section-heading">
              Repeat partnerships built on operational clarity, clean systems, and commercial execution.
            </h2>
            <p className="section-intro">
              These excerpts come from leaders who brought Ammen Consulting into launch strategy,
              CRM recovery, analytical examination, sales reporting, diligence support, and operational transition work
              across multiple companies and growth stages.
            </p>
          </div>

          <aside className="testimonials-feature surface-card">
            <span className="testimonials-feature__label">Featured client feedback</span>
            <p className="testimonials-feature__quote">"{featuredTestimonial.quote}"</p>
            <div className="testimonials-feature__footer">
              <div>
                <p className="testimonials-feature__name">{featuredTestimonial.name}</p>
                <p className="testimonials-feature__context">{featuredTestimonial.context}</p>
              </div>
              <span className="pill">{featuredTestimonial.label}</span>
            </div>
          </aside>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <article key={testimonial.id} className="testimonial-card surface-card">
              <div className="testimonial-card__header">
                <div>
                  <p className="testimonial-card__role">{testimonial.role}</p>
                  <h3>{testimonial.name}</h3>
                  <p className="testimonial-card__companies">{testimonial.companies}</p>
                </div>
                <span className="pill">{testimonial.tag}</span>
              </div>

              <blockquote
                className="testimonial-card__body"
                aria-label={`${testimonial.name} testimonial excerpt`}
              >
                {testimonial.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </blockquote>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
